module.exports = __webpack_public_path__ + "img/afterfx.37768ba2.png";